/* eslint-disable import/no-cycle */
import AccordionItem from './AccordionItem/AccordionItem'
import ArrowBtn from './ArrowBtnComponent/ArrowBtnComponent'
import CallToUsButton from './CallToUsButton/CallToUsButton'
import Carousel from './CarouselComponent/CarouselComponent'
import ContactDetailsComponent from './ContactDetailsComponent/ContactDetailsComponent'
import ContentCardComponent from './ContentCardComponent/ContentCardComponent'
import TreatmentContentCardComponent from './ContentCardComponent/TreatmentContentCard'
import CtaButtonComponent from './CtaButton/CtaButton'
import DiscoverMoreBtn from './DiscoverMoreBtn/DiscoverMoreBtn'
import ExperienceCardComponent from './ExperienceCardComponent/ExperienceCardComponent'
import ImageComponent from './ImageComponent/ImageComponent'
import LanguageSwitcher from './LanguageSwitcher/LanguageSwitcher'
import LogoComponent from './LogoComponent/LogoComponent'
import NavComponent from './NavComponent/NavComponent'
import PriceCategoryComponent from './PriceCategoryComponent/PriceCategoryComponent'
import RatingItem from './RatingItem/RatingItem'
import ReviewItem from './ReviewItem/ReviewItem'
import SectionHeader from './SectionHeader/SectionHeader'
import { SEOComponent } from './SEOComponent/SEOComponent'
import SeparatorsComponent from './SeparatorsComponent/SeparatorsComponent'
import StepItem from './StepItem/StepItem'
import TreatmentItem from './TreatmentItem/TreatmentItem'
import UspItemComponent from './UspItemComponent/UspItemComponent'
import Video from './VideoComponent/VideoComponent'

export const TreatmentDetails = TreatmentItem
export const CtaButton = CtaButtonComponent
export const DiscoverMoreIcon = DiscoverMoreBtn
export const StepItemComponent = StepItem
export const AccordionItemComponent = AccordionItem
export const ArrowBtnComponent = ArrowBtn
export const CarouselComponent = Carousel
export const RatingItemComponent = RatingItem
export const SectionHeaderComponent = SectionHeader
export const ContentCard = ContentCardComponent
export const TreatmentContentCard = TreatmentContentCardComponent
export const ContactDetails = ContactDetailsComponent
export const UspItem = UspItemComponent
export const ExperienceCard = ExperienceCardComponent
export const Separators = SeparatorsComponent
export const Review = ReviewItem
export const Image = ImageComponent
export const Nav = NavComponent
export const LanguageSwitcherComponent = LanguageSwitcher
export const Logo = LogoComponent
export const CallToUsButtonComponent = CallToUsButton
export const VideoComponent = Video
export const PriceCategory = PriceCategoryComponent
export const Seo = SEOComponent
